module.exports = __webpack_public_path__ + "img/carmoola-logo.032751e8.png";